import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/lib/router-compat";
import { ArrowRight } from "lucide-react";

interface QuickAnswerProps {
  question: string;
  answer: string;
  ctaText?: string;
  ctaLink?: string;
}

export function QuickAnswer({ question, answer, ctaText, ctaLink }: QuickAnswerProps) {
  return (
    <section className="py-12 bg-gradient-to-r from-seo-blue/10 to-seo-cyan/10 border-l-4 border-seo-bright">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4 flex items-start gap-3">
            <span className="text-seo-bright text-3xl">💡</span>
            {question}
          </h2>
          <div className="prose prose-lg prose-invert max-w-none mb-6">
            <p className="text-gray-300 text-lg leading-relaxed">{answer}</p>
          </div>
          {ctaText && ctaLink && (
            <Button asChild className="bg-gradient-to-r from-seo-blue to-seo-cyan hover:opacity-90">
              <Link to={ctaLink}>
                {ctaText}
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
          )}
        </div>
      </div>
    </section>
  );
}
